import { gql } from '@apollo/client';

export const createDocumentationSchema = gql`
  mutation CreateApplicationDocumentation($creditStudyId: String!) {
    createApplicationDocumentation(creditStudyId: $creditStudyId) {
      value
    }
  }
`;

export const specifyDocumentationTypeSchema = gql`
  mutation SpecifyApplicationDocumentationType(
    $employmentSituation: String!
    $declaresRent: Boolean!
    $documentation: String!
  ) {
    specifyApplicationDocumentationType(
      employmentSituation: $employmentSituation
      declaresRent: $declaresRent
      documentation: $documentation
    ) {
      value
    }
  }
`;
